import React, { useState, useEffect } from 'react';
import { Space, Theme } from '@cashfree-intl/coherent';
import CheckoutCardDesktopOnly from 'images/CheckoutJourney/desktopOnly.svg';
import { MainContainer, Wrapper } from 'containers/CheckoutJourney/styled';
import CheckoutCard from 'containers/CheckoutJourney/components/CheckoutCard';
import { CheckoutJourneyLayoutProps } from 'containers/CheckoutJourney/types';

import Header from './Header';
import StepNavigation from './StepNavigation';
import Footer from './Footer';

function CheckoutJourneyLayout({ children }: CheckoutJourneyLayoutProps) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (isMobile) {
    return (
      <Space
        fullWidth
        justifyContent="center"
        alignItems="center"
        style={{ height: '100vh' }}
      >
        <CheckoutCard
          imageSrc={CheckoutCardDesktopOnly}
          imageAlt="Checkout Card"
          title="Oh no, we are on desktop only!"
          description="Please try this again on a desktop device and complete the integration process."
          buttonText="I will do it later"
          buttonLink="/landing"
        />
      </Space>
    );
  }

  return (
    <Theme font="sans">
      <MainContainer direction="column" fullWidth>
        <Header />
        <StepNavigation />
        <Wrapper direction="column" alignItems="center" fullWidth>
          <Space className="mt-3" fullWidth>
            {children}
          </Space>
        </Wrapper>
        <Footer />
      </MainContainer>
    </Theme>
  );
}

export default CheckoutJourneyLayout;
